import type { InputHTMLAttributes } from "react";

import { useField } from "remix-validated-form";

import { tw } from "~/utils";

interface DashInputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label?: string;
  classNameContainer?: string;
  description?: string;
  onChange?: (e: any) => void;
}

export const dashLabelClassname = `mb-2 block text-sm font-medium text-charcoal dark:text-gray-200`;
export const dashInputClassname = `w-full focus:border-purple-400 focus:ring-purple-300 block rounded-lg border bg-white px-4 py-2 text-gray-700 focus:outline-none focus:ring focus:ring-opacity-40 disabled:cursor-not-allowed disabled:bg-slate-200`;

const DashInput = ({
  name,
  label,
  className,
  classNameContainer,
  defaultValue,
  type = "text",
  description,
  onChange,
  readOnly,
  ...rest
}: DashInputProps) => {
  const { error, getInputProps } = useField(name);
  return (
    <div className={tw("mt-4", classNameContainer)}>
      {label && (
        <label className={dashLabelClassname} htmlFor={name}>
          {label}
        </label>
      )}
      {description && (
        <p className="mb-2 text-xs text-charcoal">{description}</p>
      )}
      <input
        className={tw(
          dashInputClassname,
          `${readOnly ? "bg-slate-200" : ""}`,
          `${error ? "border-red-700 focus:border-red-700 focus:ring-red-700" : ""}`,
          className
        )}
        type={type}
        defaultValue={defaultValue}
        {...getInputProps({ id: name, onChange: onChange })}
        {...rest}
      />
      {error && (
        <span className="pt-2 text-xs text-red-700" id="email-error">
          {error}
        </span>
      )}
    </div>
  );
};

export default DashInput;
